import { ToolKind } from '../tool.types';
export var ToolModuleKind;
(function (ToolModuleKind) {
    ToolModuleKind["Activity"] = "activity";
    ToolModuleKind["Button"] = "button";
    ToolModuleKind["Countdown"] = "countdown";
    ToolModuleKind["EmailCapture"] = "emailCapture";
    ToolModuleKind["Form"] = "form";
    ToolModuleKind["Heading"] = "heading";
    ToolModuleKind["ImageWithBehaviour"] = "imageWithBehaviour";
    ToolModuleKind["Icon"] = "icon";
    ToolModuleKind["Paragraph"] = "paragraph";
    ToolModuleKind["Perks"] = "perks";
    ToolModuleKind["SavedSearch"] = "savedSearch";
    ToolModuleKind["Spacer"] = "spacer";
    ToolModuleKind["Login"] = "login";
})(ToolModuleKind || (ToolModuleKind = {}));
//# sourceMappingURL=common.types.js.map